import {
  GET_PLAN_BY_ID_LOADING,
  GET_PLAN_BY_ID_SUCCESS,
  GET_PLAN_BY_ID_FAILED,
} from "../types";
import { Plan } from "../../models/Plan";

interface GetPlanByIdState {
  data: Plan | null;
  loading: boolean;
  error: string | null;
}

const initialState: GetPlanByIdState = {
  data: null,
  loading: false,
  error: null,
};

export const getPlanByIdReducer = (
  state = initialState,
  action: any
): GetPlanByIdState => {
  switch (action.type) {
    case GET_PLAN_BY_ID_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };

    case GET_PLAN_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case GET_PLAN_BY_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: null,
      };

    default:
      return state;
  }
};

